

export const linkSendStatus ={
    forward:1,
    notForward:2,
    linkOpen:3,
    readLink:4,
    waitSend : 5
}